const PageLoader = () => (
  <div 
    className="min-h-screen flex items-center justify-center"
    style={{ background: '#E9E4DE' }}
  >
    <div 
      className="w-8 h-8 rounded-full border-2 border-t-transparent animate-spin" 
      style={{ borderColor: '#B39678', borderTopColor: 'transparent' }}
    />
  </div>
);

export default PageLoader;
